export const SET_INTEGRATION_CONFIG = "SET_INTEGRATION_CONFIG";
export const SET_INTEGRATION_ZOOM_WEBINARS = "SET_INTEGRATION_ZOOM_WEBINARS";
export const SET_INTEGRATION_SENDGRID = "SET_INTEGRATION_SENDGRID";
export const UPDATE_INTEGRATION_SENDGRID = "UPDATE_INTEGRATION_SENDGRID";
export const SET_INTEGRATION_WHATSAPP = "SET_INTEGRATION_WHATSAPP";
export const UNSUBSCRIBE_GET_INTEGRATION_WHATSAPP = "UNSUBSCRIBE_GET_INTEGRATION_WHATSAPP";
export const SET_INTEGRATION_FB_CATALOG = "SET_INTEGRATION_FB_CATALOG";
